import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './CommentItem.module.css'
import {
  Button,
  Card,
  Divider,
  Drawer,
  Flex,
  Image,
  message,
  Modal,
  Rate,
} from 'antd'
import classNames from 'classnames'
import defaultAvatar from '../avatar.png'
import { Tag } from 'antd/lib'
import { HeartFilled } from '@ant-design/icons'
import Cookies from 'js-cookie';
export default function CommentItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  return (
    <div>
      <div>
        <div className={styles.tobContainer}>
          <Image
            height={48}
            width={48}
            style={{ borderRadius: 8 }}
            src={
              props.info.image_url == undefined ||
              props.info.image_url == '' ||
              props.info.image_url == 'null'||
              props.info.image_url == null
                ? defaultAvatar
                : props.info.image_url
            }
          />
          <div className={styles.topRightDiv}>
            <h3 style={{ marginLeft: 8 }}>{props.info.name}</h3>
            <h4>{props.info.ctime.substring(0, 10)}</h4>
          </div>
        </div>
        <div style={{ marginLeft: 56 }}>
          {props.info.zonghe_pingfen == 0 ? (
            <Tag>暂无评价</Tag>
          ) : (
            <Rate
              value={props.info.zonghe_pingfen / 20}
              allowHalf
              disabled
              character={<HeartFilled />}
            />
          )}
          <div className={styles.contentDiv} style={{ marginTop: 12 }}>
            <text className={styles.contentText}>{props.info.pingjia_content}</text>
            {Cookies.get("username") == props.info.username ? (
              <div
                className={styles.deleteDiv}
                onClick={() => {
                  props.deleteComment(props.info)
                }}
              >
                删除
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <Divider style={{ borderColor: '#e7e9ec' }}></Divider>
    </div>
  )
}
